// extracted by mini-css-extract-plugin
module.exports = {"default":"styles-module--default--1QEX6"};